import React, { useState } from "react";
import { FieldError } from "../../common/fields";
import { formatPhoneNumber2 } from "../../../utils";
import { selectAutomationIdBasedOnComponent } from "../../../utils/automationIds";
import {
  Button, ButtonGroup, Radio, RadioGroup, SelectionControlLabel,
  Typography
} from "@one-thd/sui-atomic-components";
import { MESSAGE } from "../../../constants/messages";

const OtpOptionsView = (props) => {
  const {
    emailEditContext = {},
    onCancelModal,
    onClickCallback,
    isValidateNewPhone,
    origin,
    isPhoneVerified,
    errorState,
    isLandlineSMS
  } = props;

  const {
    email,
    phone, // current number associated with account
    newPhoneNumber
  } = emailEditContext;

  const [selectedOtpChannel, setSelectedOtpChannel] = useState("");

  const handleChange = (e) => {
    setSelectedOtpChannel(e.target.value);
  };

  const onSubmitOtpOption = () => {
    onClickCallback(selectedOtpChannel, origin);
  };
  const phoneNumber = isValidateNewPhone ? newPhoneNumber : phone;

  const selectedFlow = (origin === "phoneEdit") ? "phone" : "email";

  function getAction(component) {
    if (component === "cancel") {
      return "cancel"
    }
    return (origin === "phoneEdit" && component === "sendCode" && isValidateNewPhone)
      ? "sendCode"
      : "sendCodeIdentity";
  }

  let mainText;
  let otpChannel;
  if (!isLandlineSMS) {
    if (isValidateNewPhone) {
      mainText = "Now, let's verify your new phone number."
    } else if (isPhoneVerified || !isPhoneVerified) {
      otpChannel = origin === "emailEdit" ? "email address" : "phone number";
      mainText = `Before you change your ${otpChannel}, we need to confirm who you are.`;
    } else {
      mainText = "Please choose between Email or Phone to send your OTP";
    }
  } else {
    mainText = MESSAGE.SMS_LANDLINE;
  }


  return (
    <>
      <Typography>
        {mainText}
      </Typography>
      {!!errorState.length && (
        <div className="otp-options-view-error col__12-12 no-padding-sides form-input--error">
          <FieldError name="otp" errors={errorState} />
        </div>
      )}
      <Typography>How should we send the verification code?</Typography>
      <RadioGroup name='otp-choice' value={selectedOtpChannel} onChange={handleChange}>
        {!isLandlineSMS ? <SelectionControlLabel>
          <span className='sui-flex'>
            <Radio value='sms' id="sms" />
            <div className='sui-flex sui-gap-1 sui-m-auto'>
              <Typography weight='bold'>Text: </Typography>
              <Typography data-qm-mask>{formatPhoneNumber2(phoneNumber)}</Typography>
            </div>
          </span>
        </SelectionControlLabel> : <></>}
        <SelectionControlLabel>
          <span className='sui-flex'>
            <Radio value='phone' id="evoice" />
            <div className='sui-flex sui-gap-1 sui-m-auto'>
              <Typography weight='bold'>Phone Call: </Typography>
              <Typography data-qm-mask>{formatPhoneNumber2(phoneNumber)}</Typography>
            </div>
          </span>
        </SelectionControlLabel>
        {(!isValidateNewPhone) ? (
          <SelectionControlLabel>
            <span className='sui-flex'>
              <Radio value='email' id="emailId" />
              <div className='sui-flex sui-gap-1 sui-m-auto'>
                <Typography weight='bold'>Email: </Typography>
                <Typography data-qm-mask>{email}</Typography>
              </div>
            </span>
          </SelectionControlLabel>
        ) : <></>}
      </RadioGroup>
      <ButtonGroup fullWidth orientation='vertical'>
        <Button
          data-automation-id={selectAutomationIdBasedOnComponent(selectedFlow, getAction("sendCode"), isPhoneVerified)}
          variant="primary"
          onClick={onSubmitOtpOption}
          disabled={selectedOtpChannel === ""}>
          Send Code
        </Button>
        <Button
          data-automation-id={selectAutomationIdBasedOnComponent(selectedFlow, getAction("cancel"), isPhoneVerified)}
          onClick={onCancelModal}>
          Cancel
        </Button>
      </ButtonGroup>
    </>
  )
};

export default OtpOptionsView;